import { Metric } from './analytics-api/schema.model';
import { IMetricFilter } from '../interfaces/query-filter.interface';

export class MetricFilter {
  public dataset?: string;
  public type: string;
  public key: string;
  public value: number;
  public metric: Metric = undefined;

  constructor(
    object: IMetricFilter,
  ) {
    this.type = object.type;
    this.value = object.value;

    if (!!object.metric) {
      this.metric = new Metric(object.metric.name, object.metric.meta);
    }

    if (object.dataset) {
      this.dataset = object.dataset;
    }

    this.key = object.key;
  }

  public get querySegments(): string[] {
    const qs = this.queryString;
    return qs ? [qs] : [];
  }

  public get queryString(): string {
    switch (this.type) {
      case 'na':
      case 'not_na':
        return `${this.metric?.name || this.key}:${this.type === 'na' ? 'any' : 'not_any'}:`;
      default:
        return `${this.key}:${this.type}:${this.slice}`;
    }
  }

  public asJson() {
    return {
      type: this.type,
      value: this.value,
      metric: this.metric && { name: this.metric.name },
      key: this.key,
    };
  }

  private get slice() {
    return encodeURIComponent(this.value);
  }
}
